import React, { useState } from 'react';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Container from 'components/Container';
import { Link, useParams } from 'react-router-dom';
import { CaretLeftIcon } from '@phosphor-icons/react';
import { useQuery } from '@tanstack/react-query';
import { getMcp } from 'api/mcps';
import { getAssistants } from 'api/assistants';
import LoadingOverlay from 'components/LoadingOverlay';
import Button from 'components/Button';

export default function Detail() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);
    const { mcpId } = useParams();

    const { data: mcp } = useQuery({
        queryKey: ['mcps', mcpId],
        queryFn: async () => await getMcp({id: mcpId}),
        enabled: Boolean(mcpId),
    });

    const { data: assistants, isLoading: isLoadingAssistants } = useQuery({
        queryKey: ['assistants', mcpId],
        queryFn: async () => await getAssistants({
            params: {
                mcp: mcpId
            }
        }),
        enabled: Boolean(mcpId),
    });

    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <LoadingOverlay isLoading={isLoadingAssistants} />  

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container>
                    <div className='pb-8 pt-20 md:pt-14 flex justify-between items-center'>
                        <div className='flex gap-3 items-center'>
                            <Link to="/settings/mcps" className=''>
                                <CaretLeftIcon size={26} className='hover:text-muted' />
                            </Link>
                            <p className='text-3xl'>{mcp?.name}</p>
                        </div>
                        
                        <Button component={Link} to={`/settings/mcps/${mcpId}/edit`}>
                            Modifica
                        </Button>
                    </div>


                    <div className='flex gap-10'>
                        <div className='flex-1 border border-light rounded-sm'>
                            <div className='p-4'>
                                <label className='text-sm mb-1 block'>Descrizione</label>
                                <p className='text-muted'>{mcp?.description}</p>
                            </div>
                            <div className='p-4'>
                                <label className='text-sm mb-1 block'>Base URL</label>
                                <p className='text-muted'>{mcp?.baseUrl}</p>
                            </div>
                            <div className='p-4'>
                                <label className='text-sm mb-1 block'>Token di autenticazione</label>
                                <p className='text-muted'>******</p>
                            </div>
                        </div>
                    </div>

                    <div className='border border-light rounded-sm mt-6'>
                        {(!assistants || assistants?.length === 0) && (
                            <div className='p-4'>
                                <p className='text-muted'>Nessun assistente collegato a questo MCP.</p>
                            </div>
                        )}
                        {assistants?.map((assistant, index) => {
                            return (
                                <div key={index} className='group border-b last:border-0 border-light flex items-center gap-4 p-4'>
                                    <div className='flex-1'>
                                        <p className='font-semibold'>{assistant?.name}</p>
                                    </div>

                                    <div className='opacity-0 group-hover:opacity-100 flex-1 flex gap-4 justify-end items-center'>
                                        <Link to={`/assistant/${assistant._id}`} className='hover:underline'>
                                            Vedi assistente
                                        </Link>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </Container>
            </div>
        </>
    )
}
